import React, { useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { withStyles, Typography, Button } from '@material-ui/core';
import { hasPermission, createHistory, formatDate } from '../../sc-utilities';
import DeliveryNotesList from './DeliveryNotesList';
import { Redirect } from 'react-router-dom';

const styles = theme => ({
    root: {
        width: `98.9%`,
        height: 'auto',
        paddingTop: theme.spacing(),
        paddingLeft: theme.spacing(),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    },
    buttonsCustomer: {
        color: theme.palette.primary.main,
        fontSize: '13px',
        width: '100%',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.background.paper
        },
    },
});

const DeliveryNotes = props => {
    const tableRef = React.createRef();
    const { classes, columns, translations, permissions } = props;
    const [redirectOptions, setRedirectOptions] = useState({ redirect: false, customerID: null, redirectPath: '' });

    let visible = columns && columns['DeliveryNotes'];

    const redirectToCustomer = id => {
        createHistory();
        setRedirectOptions({
            redirect: true,
            customerID: id,
            redirectPath: `/admin/customers/details?customerID=${id}`
        });
    }
    const tableColumns = useMemo(() => {
        return [
            {
                title: translations['customer_name'] || 'Customer name', field: 'CustomerName',
                hidden: visible ? visible['CustomerName'] : false,
                filtering: false,
                render: rowData => {
                    return <Button key={rowData && rowData.Customer ? rowData.Customer.CustomerID : ''}
                        className={classes.buttonsCustomer} size='small'
                        onClick={() => redirectToCustomer(rowData && rowData.Customer ? rowData.Customer.CustomerID : '')}>
                        {rowData && rowData.Customer ? rowData.Customer.Name : translations['short_not_assigned'] || 'n/a'}
                    </Button>;
                }
            },
            {
                title: translations['billed'] || 'Billed', field: 'Billed',
                hidden: visible ? visible['Billed'] : false,
                lookup: { '0': translations['no'] || 'No', '1': translations['yes'] || 'Yes' },
                defaultFilter: ['0', '1'],
                filtering: true,
                render: rowData => {
                    return <Typography variant={'caption'}>{rowData.Billed ? translations['yes'] || 'Yes' : translations['no'] || 'No'}</Typography>;
                }
            },
            {
                title: translations["billed_date"] || 'Billed date', field: 'BilledDate',
                hidden: visible ? visible['BilledDate'] : false,
                type: 'date',
                render: rowData => {
                    return <Typography variant={'caption'}>{rowData.CreatedAt ? formatDate(rowData.CreatedAt) : translations['short_not_assigned'] || 'n/a'}</Typography>;
                }
            },
            {
                title: translations["consumed_credits"] || 'Consumed credits', field: 'ConsumedCredits',
                hidden: visible ? visible['ConsumedCredits'] : false,
                filtering: false,
                render: rowData => {
                    return <Typography variant={'caption'}>{rowData.ConsumedCredits ? rowData.ConsumedCredits : translations['short_not_assigned'] || 'n/a'}</Typography>;
                }
            }
        ];
    }, [classes, translations, visible]);

    if (redirectOptions.redirect) {
        return <Redirect to={redirectOptions.redirectPath} />;
    }

    return (
        <div className={classes.root}>
            {hasPermission(permissions, 'delivery_note_list') ?
                <DeliveryNotesList
                    tableColumns={tableColumns}
                    tableRef={tableRef}
                />
                :
                null}
        </div>
    );
};

const mapStateToProps = state => {
    return {
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        columns: state.core.login.userSettings ? state.core.login.userSettings.Columns : null,
        permissions: state?.core?.login?.permissions || []
    };
};

export default connect(
    mapStateToProps,
    null
)(withStyles(styles)(DeliveryNotes));